import React from 'react';
import { useNavigate } from 'react-router-dom';
import listener from '@/layout/goldenLayoutListener';
import TabPage from '../containers/TabPage';

const PanelPage = () => {
  const navigate = useNavigate();
  listener.listenToNavigate(({ url }) => navigate(url));

  return (<TabPage />);
};

export default PanelPage;
